export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14182.10422b27.jpg";